import React from 'react';
import styled from 'styled-components';
import { GridContainer, Formatted } from '@agilytics/components';
import content from './content.json';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  margin: auto;
  margin-bottom: ${({ theme }) => theme.spacingTriple};
  text-align: left;
  padding: 0px ${({ theme }) => theme.spacingDouble};
`;

export default function Privacy() {
  return (
    <GridContainer>
      <Container>
        <Formatted content={content.content} />
      </Container>
    </GridContainer>
  );
}
